import React from "react";

const SectionHeader = ({ title, className = "" }) => {
  return (
    <div className={`flex items-center justify-between my-1 ${className}`}>
      <div>
        <h2 className=" md:text-2xl font-semibold bg-gradient-to-r from-primary-500 via-primary-600 to-primary-800 bg-clip-text text-transparent">
          {title}
        </h2>
        <div
          className={`w-12 h-[2px] bg-gradient-to-r from-primary-500 via-primary-600 to-primary-800 mt-1 rounded-full`}
        />
      </div>
    </div>
  );
};

export default SectionHeader;
